import { Link } from "react-router-dom";
import { eventList } from "@/mocks/events";
import { hotTopics } from "@/mocks/site";
import StatusBadge from "@/components/feature/StatusBadge";
import { formatShortDate, getCategoryName, sortByUpdated } from "@/lib/eventUtils";

export default function LatestUpdates() {
  const updates = sortByUpdated(eventList).slice(0, 6);
  const hottest = [...eventList].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <section className="w-full px-5 md:px-10 py-14 md:py-20 bg-background-100">
      <div className="flex flex-col lg:flex-row gap-10 lg:gap-14">
        <div className="lg:w-[58%]">
          <div className="flex items-end justify-between gap-4">
            <div>
              <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.22em] text-primary-600 font-medium">
                <span className="w-5 h-px bg-primary-400" />
                最新进展
              </span>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                最近更新的事件与节点
              </h2>
            </div>
            <Link
              to="/events"
              className="hidden md:inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-600 whitespace-nowrap cursor-pointer"
            >
              全部事件
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <ul className="mt-8">
            {updates.map((item) => (
              <li
                key={item.id}
                className="relative pl-6 pb-6 last:pb-0 border-l border-dashed border-background-300"
              >
                <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100" />
                <div className="flex flex-wrap items-center gap-3">
                  <time className="text-xs font-medium text-foreground-500" dateTime={item.updatedAt}>
                    {formatShortDate(item.updatedAt)}
                  </time>
                  <span className="text-[11px] text-foreground-600">
                    {getCategoryName(item.category)}
                  </span>
                  <StatusBadge status={item.status} />
                </div>
                <h3 className="mt-2 font-heading text-sm md:text-base font-bold text-foreground-950 leading-snug">
                  <Link to={`/events/${item.id}`} className="hover:text-primary-700 transition-colors cursor-pointer">
                    {item.title}
                  </Link>
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600 line-clamp-2">
                  {item.summary}
                </p>
              </li>
            ))}
          </ul>
        </div>

        <aside className="lg:w-[42%] flex flex-col gap-8">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
              <i className="ri-fire-line text-primary-500" />
              热度排行
            </h3>
            <ol className="mt-4 space-y-3.5">
              {hottest.map((item, index) => (
                <li key={item.id} className="flex items-start gap-3">
                  <span
                    className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-md font-heading text-xs font-bold ${
                      index < 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <Link
                    to={`/events/${item.id}`}
                    className="text-sm text-foreground-800 leading-snug hover:text-primary-700 transition-colors cursor-pointer line-clamp-2"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <div className="rounded-lg border border-accent-200 bg-accent-50 p-5 md:p-6">
            <h3 className="font-heading text-base font-bold text-accent-900 flex items-center gap-2">
              <i className="ri-price-tag-3-line" />
              大家都在搜
            </h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotTopics.map((topic) => (
                <Link
                  key={topic.label}
                  to="/events"
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 border border-accent-200 text-xs text-foreground-700 hover:border-accent-400 hover:text-accent-800 transition-colors cursor-pointer"
                >
                  {topic.label}
                  <span className="text-[10px] text-foreground-500">{topic.count}</span>
                </Link>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}